
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code7 } from "./data";

export default defineComponent({
  name: "simple-step-bar",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code7
    };
  }
});
